import Vue from 'vue'
import Router from 'vue-router'
import Resource from 'vue-resource'
import App from './layout/App.vue'
import Element from 'element-ui'
import router from './router/index'


import 'element-ui/lib/theme-default/index.css'
import './assert/css/base.css'
import './assert/css/style.css'

Vue.use(Element)
Vue.use(Router)
Vue.use(Resource)

let app = new Vue({
    router,
    ...App
}).$mount('#app')


// WEBPACK FOOTER //
// ./src/index.js